var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-progress',{attrs:{"variant":_vm.variant,"value":_vm.value,"animated":false}})}
var staticRenderFns = []

export { render, staticRenderFns }